import {
  ListItem, ListItemButton, ListItemIcon, ListItemText,
} from '@datanomik/commons-ui';
import { t } from 'i18next';
import { useState } from 'react';
import { SupportIcon } from '../shared/icons/SupportIcon';
import { SupportPanelDrawer } from '../support-panel/SupportPanelDrawer';

export const SupportMenuItem = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      <ListItem>
        <ListItemButton
          selected={false}
          component="a"
          disabled={false}
          onClick={() => setDrawerOpen(true)}
        >
          <ListItemIcon><SupportIcon /></ListItemIcon>
          <ListItemText primary={t('Support')} />
        </ListItemButton>
      </ListItem>
      <SupportPanelDrawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </>
  );
};
